<template>
  <div>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <span class="pointer" v-on="on" @click="form.opened = true"><v-icon color="primary">mdi-priority-high</v-icon></span>
      </template>
      <span>Изменить приоритет</span>
    </v-tooltip>

    <v-dialog persistent v-model="form.opened" max-width="600px" @keydown.esc="cancel" v-on:keydown.enter="saveItem">
      <v-card light>
        <v-card-title class="headline white--text" :class="form.color">{{ form.title }}
          <v-spacer></v-spacer>
          <a class="close" @click="cancel">×</a>
        </v-card-title>

          <v-card-text class="title pa-4 mt-0">
            <v-select
              :items="items.priorities"
              v-model="item.priority"
              label="Приоритет"
              item-value="value"
              item-text="name"
              no-data-text="Нет результатов"
              hide-details
              class=""
            ></v-select>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :class="form.color" :loading="form.pendingSave" @click="saveItem" :disabled="disabled">
              <v-icon small class="mr-2">mdi-content-save</v-icon>
              {{ $t('buttons.save')}}
            </v-btn>
          </v-card-actions>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { get, edit, getAll, xls } from '@/api'
import RefMixin from '@/views/Ref.vue'
export default {
  mixins: [RefMixin],
  components: {
  },
  props: {
    id: {
      type: Number
    },
    url: {
      type: String
    },
    item: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  watch: {
  },
  data: function () {
    return {
      disabled: false,

      form: {
        opened: false,
        color: 'primary',
        title: 'Изменить приоритет',
        pendingSave: false,
      },
      //
      loadingRefs: {},

      items: {
        priorities: [
          { name: 'Блокирующий', value: 'blocking' },
          { name: 'Высокий', value: 'high' },
          { name: 'Нормальный', value: 'medium' },
          { name: 'Желательный', value: 'low' },
        ],
      },
    }
  },
  methods: {
    cancel () {
      this.form.opened = false
    },
    saveItem () {
      this.form.pendingSave = true
      this.$store.commit('SET_LOADING', true)

      edit(this.url, this.id, this.item, 'change/').then((response) => {
        this.form.pendingSave = false
        this.$store.commit('SET_LOADING', false)
        this.$notify({ group: 'main', title: 'Сохранить', text: 'Успешно!', type: 'success' })
        this.form.opened = false
        this.$emit('load')
      }).catch((err) => {
        console.log('ERRR', err)
        this.form.pendingSave = false
        this.$notify({ group: 'main', title: 'Сохранить', text: 'Ошибка! ' + err.response.status + ' ' + err.response.statusText, type: 'error' })
        this.$store.commit('SET_LOADING', false)
        this.form.opened = false
      })
    },
  },
  mounted () {
  },
  created () {
  }
}
</script>
<style scoped>
</style>
